/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.searchModule',
  ['restangular', 'ui.router', 'bulbApp.configModule', 'bulbApp.errorModule', 'bulbApp.filtersModule',
    'bulbApp.translateModule'])

.constant('SEARCH', {
  MIN_PREFIX_LENGTH: 2,
  SEARCH_RESULTS_STATE: 'searchresults',
  SEARCH_RESULTS_SIZE: 20
})

.config(['$stateProvider', 'SEARCH', function($stateProvider, SEARCH) {
  $stateProvider
  .state(SEARCH.SEARCH_RESULTS_STATE, {
    // DO LATER : When navigating Back or Forward, remember where page was scrolled to.
    parent: 'bulbView',
    url: '^/b/search?{query}&{userUnitId}&{scope}',
    resolve: {
      // If any of the promises are rejected the $stateChangeError event is fired.
      initialResults: ['$stateParams', 'BulbSearchService', 'SEARCH', 'BulbBusyService', 
        function($stateParams, BulbSearchService, SEARCH, BulbBusyService) {
          if ($stateParams.query) {
            var scope = $stateParams.scope || ($stateParams.userUnitId ? 'PORTFOLIO' : 'ALL');
            return BulbBusyService.showBusyDuring(
              BulbSearchService.search(
                $stateParams.query,
                $stateParams.userUnitId || null,
                scope,
                0,
                SEARCH.SEARCH_RESULTS_SIZE
              )
            );
          }
          return {};
        }
      ],
      $title: ['$stateParams', '$translate', function($stateParams, $translate) {
        if ($stateParams.query) {
          return $translate('search_results_title', {query: decodeURIComponent($stateParams.query)});
        }
        return $translate('search_title');
      }]
    },
    views: {
      bulbView: {
        templateUrl: 'ajs/search/searchresults.html',
        controller: 'SearchResultsController as searchResultsCtrl'
      }
    }
  });
}]);
